import(/* webpackMode: "eager", webpackExports: ["ApiReferencePageContent"] */ "/vercel/path0/src/components/inbound-gpt/resources-pages.tsx");
